/**
 * Scripts
 */

import paramControl from '../scripts/paramControl';
import bodyClass from '../scripts/bodyclass';
import disableHover from '../scripts/disableHover';
import browserDetect from '../scripts/bowser';
import resizeClass from '../scripts/resizeClass';
import '../scripts/lazyloading';
import '../scripts/fontfaceobserver';
// import '../scripts/pagetransition'
// import '../scripts/smoothScroll'
// import '../scripts/waypoints.anime'


// Modules Array
const scriptsArray = [
    paramControl,
    bodyClass,
    disableHover,
    browserDetect,
    resizeClass
];

const scripts = {
    // Scripts
    Scripts() {
        if (scriptsArray.length > 0 && scriptsArray !== undefined) {
            scriptsArray.forEach((script) => {
                script.init();
            });
        }
    },

    init() {
        this.Scripts();
    }
};

export default scripts;



// WEBPACK FOOTER //
// ./___src/assets/js/partials/scripts.js